import React, { Fragment } from 'react';
import ManageAPIKey from './ManageApiKey';

// Thin route entry — the V3 shell lives inside the view.
const ApiKey = () => (
    <Fragment>
        <ManageAPIKey />
    </Fragment>
);

export default ApiKey;
